
import { Vue, Component } from 'vue-property-decorator'
@Component({
  name: 'homeOld.vue'
})
export default class home extends Vue {
  myChart = ''
  myBar = ''
  countContract = {}
  countZgxq = {}
  articles = []
  baxbtj = ''
  banltj = ''
  baztj = ''
  fktj = ''
  zbtj = ''
  credientCount = ''
  lrtj = ''
  ltlrtj = ''
  guesttime = this.$moment(new Date()).format('YYYY-MM-DD')
  mounted() {
    this.drawLine()
    this.getCountContract()
    this.getCountZgxq()
    this.getArticles()
  }
  drawLine() {
    // 基于准备好的dom，初始化echarts实例
    this.myChart = this.$echarts.init(document.getElementById('myChart'))
    this.myBar = this.$echarts.init(document.getElementById('myBar'))
    this.baxbtj = this.$echarts.init(this.$refs.baxbtj)
    this.banltj = this.$echarts.init(this.$refs.banltj)
    this.baztj = this.$echarts.init(this.$refs.baztj)
    this.fktj = this.$echarts.init(this.$refs.fktj)

    this.zbtj = this.$echarts.init(this.$refs.zbtj)
    // 绘制图表
    this.myChart.setOption({
      title: {},

      tooltip: {
        trigger: 'axis'
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true
      },
      xAxis: {
        type: 'category',
        boundaryGap: false,
        data: []
      },
      yAxis: {
        type: 'value',
        axisTick: {
          //y轴刻度线
          show: false
        },
        axisLine: {
          show: false
        }
      },
      series: [
        {
          data: [],
          type: 'line',
          smooth: true
        }
      ]
    })
    this.myBar.setOption({
      title: {},
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow'
        }
      },
      xAxis: {
        type: 'category',
        data: [],
        axisLabel: {
          interval: 0,
          rotate: 40
        }
      },
      yAxis: {
        type: 'value',
        axisTick: {
          //y轴刻度线
          show: false
        },
        axisLine: {
          show: false
        }
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '15%',
        containLabel: true
      },
      series: []
    })
    this.baxbtj.setOption({
      tooltip: {
        trigger: 'item'
      },
      series: [
        {
          name: '保安性别统计',
          type: 'pie',
          radius: ['40%', '70%'],
          avoidLabelOverlap: false,
          label: {
            show: true,
            position: 'outside',
            formatter: '{b}\n{d}%',
            color: '#4089FF'
          },
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          },
          data: []
        }
      ]
    })
    this.banltj.setOption({
      title: {
        text: ''
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow'
        },
        formatter: function(params, ticket, callback) {
          console.log(params)
          var res = params[0].name
          for (var i = 0, l = params.length; i < l; i++) {
            res += '<br/>' + params[i].seriesName + ' : ' + Math.abs(params[i].value)
          }
          return res
        }
      },
      legend: {
        data: ['男', '女']
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true
      },
      xAxis: {
        type: 'value',
        boundaryGap: [0, 0.01],
        axisTick: {
          show: false //不显示坐标轴刻度线
        },
        axisLine: {
          show: false //不显示坐标轴线
        },
        axisLabel: {
          show: false //不显示坐标轴上的文字
        },
        splitLine: {
          //网格线
          show: false
        }
      },
      yAxis: {
        type: 'category',
        axisTick: {
          show: false
        },
        axisLine: {
          show: false //不显示坐标轴线
        },
        splitLine: {
          //网格线
          show: false
        },
        data: ['0-30岁', '30岁-35岁', '35岁-40岁', '40岁-45岁', '45岁-50岁', '50岁-55岁', '55岁-60岁']
      },
      series: [
        {
          name: '男',
          type: 'bar',
          data: [432, 235, 651, 424, 112, 325, 200]
        },
        {
          name: '女',
          type: 'bar',
          data: [215, 235, 11, 545, 334, 452, 6]
        }
      ]
    })
    this.baztj.setOption({
      tooltip: {
        trigger: 'item',

        formatter: '{b} : {c} ({d}%)'
      },
      legend: {
        top: '5%',
        left: 'center'
      },
      series: [
        {
          name: '保安证统计',
          type: 'pie',
          radius: ['50%', '70%'],
          avoidLabelOverlap: false,

          label: {
            show: true,
            position: 'center',
            formatter: function(params, ticket, callback) {
              return '证件\n统计'
            },
            color: '#000',
            fontSize: '35'
          },
          labelLine: {
            show: false
          },
          data: [{ value: 1048, name: '有保安证' }, { value: 735, name: '无保安证' }]
        }
      ]
    })
    this.fktj.setOption({
      tooltip: {
        trigger: 'item'
      },
      legend: {
        top: '0%',
        left: 'center'
      },
      series: [
        {
          name: '访客类型',
          type: 'pie',
          radius: '50%',
          center: ['50%', '60%'],
          data: [{ value: 1048, name: '搜索引擎' }, { value: 735, name: '直接访问' }, { value: 580, name: '邮件营销' }, { value: 484, name: '联盟广告' }, { value: 300, name: '视频广告' }],
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          }
        }
      ]
    })

    this.zbtj.setOption({
      title: {
        text: ''
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow'
        }
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true
      },
      xAxis: {
        type: 'category',
        data: ['库存', '入库数', '出库数'],
        axisTick: {
          //y轴刻度线
          show: false
        },
        axisLine: {
          show: false
        }
      },
      yAxis: {
        type: 'value',
        boundaryGap: [0, 0.01],
        axisTick: {
          //y轴刻度线
          show: false
        },
        splitLine: {
          //网格线
          show: false
        }
      },
      series: [
        {
          data: [
            {
              value: 120,
              itemStyle: {
                color: '#389c00'
              }
            },
            {
              value: 200,
              itemStyle: {
                color: '#a90000'
              }
            },
            150
          ],
          type: 'bar'
        }
      ]
    })
    if (this.isAuth('home:lrtj')) {
      this.lrtj = this.$echarts.init(this.$refs.lrtj)
      this.ltlrtj = this.$echarts.init(this.$refs.ltlrtj)
      this.ltlrtj.setOption({
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        legend: {
          data: ['盈利', '亏损']
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            axisTick: {
              show: false
            },
            data: ['周一', '周二', '周三', '周四', '周五', '周六', '周日']
          }
        ],
        yAxis: [
          {
            type: 'value',
            axisTick: {
              //y轴刻度线
              show: false
            },
            axisLine: {
              show: false
            },
            splitLine: {
              //网格线
              show: false
            }
          }
        ],
        series: [
          {
            name: '盈利',
            type: 'bar',
            stack: '总量',
            label: {
              show: true
            },
            emphasis: {
              focus: 'series'
            },
            itemStyle: {
              color: '#4089FF'
            },
            data: [320, 302, 341, 374, 390]
          },
          {
            name: '亏损',
            type: 'bar',
            stack: '总量',
            label: {
              show: true
            },
            emphasis: {
              focus: 'series'
            },
            itemStyle: {
              color: '#DD503E'
            },
            data: [[5, -111], [6, -210]]
          }
        ]
      })
      this.lrtj.setOption({
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        legend: {
          data: ['盈利', '亏损']
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            axisTick: {
              show: false
            },
            data: ['周一', '周二', '周三', '周四', '周五', '周六', '周日']
          }
        ],
        yAxis: [
          {
            type: 'value',
            axisTick: {
              //y轴刻度线
              show: false
            },
            axisLine: {
              show: false
            },
            splitLine: {
              //网格线
              show: false
            }
          }
        ],
        series: [
          {
            name: '盈利',
            type: 'bar',
            stack: '总量',
            label: {
              show: true
            },
            itemStyle: {
              color: '#4089FF'
            },
            emphasis: {
              focus: 'series'
            },
            data: [320, 302, 341, 374, 390]
          },
          {
            name: '亏损',
            type: 'bar',
            stack: '总量',
            label: {
              show: true
            },
            itemStyle: {
              color: '#DD503E'
            },
            emphasis: {
              focus: 'series'
            },
            data: [[5, -111], [6, -210]]
          }
        ]
      })
    }
    this.getHasCredentialUserCount()
    this.chartsWeekZg()
    this.chartsTodayZg()
    this.chartsBaAge()
    this.chartsBaxb()
    this.chartsZbtj()
    this.chartsGuestType()
  }
  toFktj() {
    this.$router.push({ path: '/bjba/guest/log' })
  }
  chartsWeekZg() {
    this.myChart.showLoading()
    this.$request({
      url: '/bjba/indexCount/chartsWeekZg',
      method: 'get'
    })
      .then(response => {
        console.log(response)
        var seriesData = []
        for (var i = 0; i < response.data.data.series.length; i++) {
          var example = {
            name: response.data.data.series[i].name,
            type: 'line',
            data: response.data.data.series[i].data,
            itemStyle: response.data.data.series[i].itemStyle,
            lineStyle: response.data.data.series[i].lineStyle
          }
          seriesData.push(example)
        }
        this.myChart.hideLoading()
        this.myChart.setOption({
          legend: {
            data: response.data.data.legendData
          },
          xAxis: {
            data: response.data.data.xAxisData
          },
          series: seriesData
        })
      })
      .catch(error => {
        console.log(error)
      })
  }
  chartsTodayZg() {
    this.$request({
      url: '/bjba/indexCount/chartsTodayZg',
      method: 'get'
    })
      .then(response => {
        console.log(response)
        var seriesData = []
        for (var i = 0; i < response.data.data.series.length; i++) {
          var example = {
            name: response.data.data.series[i].name,
            type: 'bar',
            data: response.data.data.series[i].data,
            itemStyle: response.data.data.series[i].itemStyle
          }
          seriesData.push(example)
        }
        this.myBar.setOption({
          legend: {
            data: response.data.data.legendData
          },
          xAxis: {
            data: response.data.data.xAxisData
          },
          series: seriesData
        })
      })
      .catch(error => {
        console.log(error)
      })
  }
  chartsBaAge() {
    this.$request({
      url: '/bjba/indexCount/getBaAge',
      method: 'get'
    })
      .then(response => {
        console.log(response)
        var seriesData = []
        for (var i = 0; i < response.data.data.series.length; i++) {
          var example = {
            name: response.data.data.series[i].name,
            type: 'bar',
            data: response.data.data.series[i].data,
            itemStyle: response.data.data.series[i].itemStyle
          }
          seriesData.push(example)
        }
        this.banltj.setOption({
          legend: {
            data: response.data.data.legendData
          },
          xAxis: {
            data: response.data.data.xAxisData
          },
          series: seriesData
        })
      })
      .catch(error => {
        console.log(error)
      })
  }
  chartsBaxb() {
    this.$request({
      url: '/bjba/indexCount/countUserWithXb',
      method: 'get'
    })
      .then(response => {
        this.baxbtj.setOption({
          series: {
            data: response.data.data
          }
        })
      })
      .catch(error => {
        console.log(error)
      })
  }
  chartsZbtj() {
    this.$request({
      url: '/bjba/indexCount/getZbtj',
      method: 'get'
    })
      .then(response => {
        var seriesData = []
        for (var i = 0; i < response.data.data.series.length; i++) {
          var example = {
            type: 'bar',
            data: response.data.data.series[i].data,
            itemStyle: response.data.data.series[i].itemStyle
          }
          seriesData.push(example)
        }
        this.zbtj.setOption({
          xAxis: {
            data: response.data.data.xAxisData
          },
          series: seriesData
        })
      })
      .catch(error => {
        console.log(error)
      })
  }
  chartsGuestType() {
    this.$request({
      url: `/bjba/indexCount/getGuestCount/${this.guesttime}`,
      method: 'get'
    })
      .then(response => {
        this.fktj.setOption({
          series: {
            data: response.data.data
          }
        })
      })
      .catch(error => {
        console.log(error)
      })
  }
  getCountContract() {
    this.$request({
      url: '/bjba/indexCount/countContract',
      method: 'get'
    })
      .then(response => {
        console.log(response)
        this.countContract = response.data.data
      })
      .catch(error => {
        console.log(error)
      })
  }
  getCountZgxq() {
    this.$request({
      url: '/bjba/indexCount/countZgxq',
      method: 'get'
    })
      .then(response => {
        console.log(response)
        this.countZgxq = response.data.data
      })
      .catch(error => {
        console.log(error)
      })
  }
  getText(type) {
    if (type) {
      if (type == 1) {
        if (this.countContract.countWorkContract) {
          return `有${this.countContract.countWorkContract}名人员合同即将到期`
        } else return '暂无'
      } else if (type == 2) {
        if (this.countContract.customerContract) {
          return `有${this.countContract.customerContract}份服务合同即将到期`
        } else return '暂无'
      } else if (type == 3) {
        if (this.countContract.txUserCount) {
          return `有${this.countContract.txUserCount}名人员将要退休`
        } else return '暂无'
      } else if (type == 4) {
        if (this.countContract.expiredEquipContract && this.countContract.expiringEquipContract) {
          return `有${this.countContract.expiredEquipContract}个装备已经过期，${this.countContract.expiringEquipContract}个装备将要过期`
        } else return '暂无'
      }
    }
  }
  toContract(type) {
    if (type) {
      if (type == 1) {
        this.$router.push({ path: '/bjba/workContractExpire' })
      } else if (type == 2) {
        this.$router.push({ path: '/bjba/customer/contract' })
      } else if (type == 3) {
        this.$router.push({ path: '/bjba/yhgl/txyhgl' })
      } else if (type == 4) {
        this.$router.push({ path: '/bjba/equip/expire' })
      }
    }
  }

  getArticles() {
    this.$request({
      url: '/bjba/article/queryAll',
      method: 'get',
      params: { isIndexScroll: 1 }
    })
      .then(response => {
        console.log(response)
        this.articles = response.data.data
      })
      .catch(error => {
        console.log(error)
      })
  }
  getTitle(str) {
    var value = ''
    if (str) {
      if (str.length > 20) {
        value = str.substr(0, 20)
        value += '...'
      } else value = str
    }
    return value
  }
  readArticle(id) {
    this.$router.push({
      path: '/bjba/article/read',
      query: { id: id }
    })
  }
  get limitArticles() {
    return this.articles.slice(0, 5)
  }

  getHasCredentialUserCount() {
    this.$request({
      url: '/bjba/indexCount/getHasCredentialUserCount',
      method: 'get'
    })
      .then(response => {
        this.credientCount = response.data.data
        var datas = []
        var data1 = { value: this.credientCount.hasCredentialUser, name: '有保安证', itemStyle: { color: '#4089FF' } }
        var data2 = { value: this.credientCount.noCredentialUser, name: '无保安证', itemStyle: { color: '#FECD5D' } }
        datas.push(data1)
        datas.push(data2)
        this.baztj.setOption({
          series: {
            data: datas
          }
        })
      })
      .catch(error => {
        console.log(error)
      })
  }
}
